import { Checkbox, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SwitchR from 'react-switch';
import 'sweetalert2/src/sweetalert2.scss';
import {
  fetchAllFlagsByDocumentUrl,
  setFilterByThumbs,
  setFilters,
  setFlagFilters,
  setPdfFlags,
  setTypeFilter
} from '../../../redux/actions/pdf-actions';
import { firebase } from '../../../firebase';
import thumbsDownImg from '../../../images/thumbs-down-grey.png';
import thumbsActive from '../../../images/thumbs-filter-btn-active.png';
import thumbsInactive from '../../../images/thumbs-filter-btn-inactive.png';
import thumbsUpImg from '../../../images/thumbs-up-grey.png';
import {
  getRetrievalTagValue,
  isRetrievalTag
} from '../../../utils/tagValidatorUtils';
import { applyFilters, groupedByText } from '../utils/utils';
import LoadingButton from '../../../components/ui/button/LoadingButton';
import '../styles/pdfViewer.css';

const useStyles = makeStyles({
  root: {
    width: '135px',
    height: '24px',
    padding: '0px'
  },
  switchBase: {
    color: '#818181',
    padding: '1px',
    '&$checked': {
      '& + $track': {
        backgroundColor: '#a8a8a8'
      }
    }
  },
  thumb: {
    color: '#E8E8E8',
    width: '65px',
    height: '20px',
    margin: '1px',
    borderRadius: '10px'
  },
  track: {
    borderRadius: '30px',
    backgroundColor: '#a8a8a8',
    opacity: '1 !important',
    '&:after, &:before': {
      color: '#4d4d4f',
      fontSize: '13px',
      position: 'absolute',
      top: '5px',
      padding: '0 6px',
      fontWeight: '600'
    },
    '&:after': {
      content: "'User'",
      left: '8px'
    },
    '&:before': {
      content: "'Tag'",
      right: '18px'
    }
  },
  checked: {
    color: '#a8a8a8 !important',
    transform: 'translateX(67px) !important'
  }
});

const Filters = ({
  show,
  handleClose,
  uniqueSharers,
  instance,
  setFlagsToShowOnRight,
  documentUrl,
  podcastUrl,
  clickMyFlags,
  clickSharedFlags,
  clickAiFlags,
  setClickSharedFlags,
  setClickAiFlags,
  getAllFlagsByDocumentUrl,
  setFilters,
  setPdfFlags,
  setFilterByThumbs,
  filterByThumbs,
  setTypeFilter,
  isLoadingFilters,
  setIsLoadingFilters,
  setFlagFilters
}) => {
  const classes = useStyles();

  const [tagsByFlags, setTagsByFlags] = useState([]);
  const [displayFTag, setDisplayFTag] = useState(false);
  const [displayFUser, setDisplayFUser] = useState(false);
  const [isCheckedAll, setIsCheckedAll] = useState(true);
  const [isCheckedUp, setIsCheckedUp] = useState(false);
  const [isCheckedDown, setIsCheckedDown] = useState(false);
  const [isCheckedUntagged, setIsCheckedUntagged] = useState(false);
  const [listOfTags, setListOfTags] = useState(['all']);
  const [checkedTags, setCheckedTags] = useState({});
  const [listOfUsers, setListOfUsers] = useState([]);
  const [clickThumbs, setClickThumbs] = useState(false);

  const handleChangeSwitch = (e, opt) => {
    if (opt !== 'all') {
      e
        ? (setIsCheckedAll(false), setListOfTags([...listOfTags, opt]))
        : (setListOfTags(listOfTags.filter((tag) => tag !== opt)),
          listOfTags.length === 2
            ? setIsCheckedAll(true)
            : setIsCheckedAll(false));
      setCheckedTags((prevState) => ({
        ...prevState,
        [opt]: !prevState[opt]
      }));
    } else {
      e
        ? (setListOfTags([opt]),
          setIsCheckedUp(false),
          setIsCheckedDown(false),
          setIsCheckedUntagged(false),
          setCheckedTags((prevState) => ({
            [opt]: !prevState[opt]
          })))
        : setListOfTags(listOfTags.filter((tag) => tag !== opt));
    }
    if (opt === 'all') {
      setIsCheckedAll(!isCheckedAll);
    } else if (opt === 'UPTAG') {
      setIsCheckedUp(!isCheckedUp);
    } else if (opt === 'DOWNTAG') {
      setIsCheckedDown(!isCheckedDown);
    } else if (opt === 'Untagged') {
      setIsCheckedUntagged(!isCheckedUntagged);
    }
  };

  const handleChangeCheckbox = (e, opt) => {
    let myList = listOfUsers;
    if (e.target.checked) {
      if (opt !== 'thumbs') {
        if (opt === 'shared') {
          myList = uniqueSharers.map((item) => item.userId);
        } else {
          if (
            uniqueSharers?.length === 1 ||
            myList?.length + 1 === uniqueSharers?.length
          ) {
            myList.push('shared');
          }
        }
        setListOfUsers([...myList, opt]);
      } else {
        setClickThumbs(true);
        setTypeFilter(null);
        setDisplayFTag(false);
      }
    } else {
      if (opt !== 'thumbs') {
        if (opt === 'shared') {
          setListOfUsers([]);
        } else {
          myList = listOfUsers.filter(
            (user) => user !== 'shared' && user !== opt
          );
          setListOfUsers([...myList]);
        }
      } else {
        setClickThumbs(false);
        setTypeFilter(null);
      }
    }
  };

  const handleClickFTag = () => {
    if (clickThumbs) {
      setDisplayFTag(false);
    } else {
      setDisplayFTag(!displayFTag);
    }
  };

  const handleClickFUser = () => {
    setDisplayFUser(!displayFUser);
  };

  const open = Boolean(show);
  const id = open ? 'simple-popover' : undefined;

  const renderApplyFiltersButton = () => {
    return (
      <div className="apply-filters-button-container">
        <LoadingButton
          isLoading={isLoadingFilters}
          text="Apply Filters"
          onClick={handleClickApplyFilters}
          disabled={isLoadingFilters}
        />
      </div>
    );
  };

  const renderFilterByTag = () => {
    return (
      <div className="filter-item">
        <div className="filter-item-div">
          <div className="filter-item-header">{'Filter by tag'}</div>
          <div
            style={{ cursor: clickThumbs ? 'not-allowed' : 'pointer' }}
            onClick={handleClickFTag}
          >
            {!displayFTag ? (
              <i
                className="fa fa-chevron-down"
                aria-hidden="true"
                style={{ color: 'rgb(139, 142, 148)' }}
              ></i>
            ) : (
              <i
                className="fa fa-chevron-up"
                aria-hidden="true"
                style={{ color: 'rgb(139, 142, 148)' }}
              ></i>
            )}
          </div>
        </div>
        <div style={{ display: !displayFTag ? 'none' : 'block' }}>
          <div style={{ display: 'flex', marginBottom: '5px' }}>
            <SwitchR
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#7634a9"
              offColor="#ccc"
              onChange={(e) => handleChangeSwitch(e, 'all')}
              checked={isCheckedAll}
              className="react-switch"
            />
            <span style={{ marginLeft: '5px', color: 'rgb(139, 142, 148)' }}>
              All
            </span>
          </div>
          {tagsByFlags?.includes('Untagged') ? (
            <div style={{ display: 'flex', marginBottom: '5px' }}>
              <SwitchR
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#7634a9"
                offColor="#ccc"
                onChange={(e) => handleChangeSwitch(e, 'Untagged')}
                checked={isCheckedUntagged}
                className="react-switch"
              />
              <span style={{ marginLeft: '5px', color: 'rgb(139, 142, 148)' }}>
                Untagged
              </span>
            </div>
          ) : (
            <></>
          )}
          {tagsByFlags?.includes('UPTAG') ? (
            <div style={{ display: 'flex', marginBottom: '5px' }}>
              <SwitchR
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#E31690"
                offColor="#ccc"
                onChange={(e) => handleChangeSwitch(e, 'UPTAG')}
                checked={isCheckedUp}
                className="react-switch"
              />
              <span style={{ marginLeft: '5px' }}>
                <img src={thumbsUpImg} />
              </span>
            </div>
          ) : (
            <></>
          )}
          {tagsByFlags?.includes('DOWNTAG') ? (
            <div style={{ display: 'flex', marginBottom: '5px' }}>
              <SwitchR
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#E31690"
                offColor="#ccc"
                onChange={(e) => handleChangeSwitch(e, 'DOWNTAG')}
                checked={isCheckedDown}
                className="react-switch"
              />
              <span style={{ marginLeft: '5px' }}>
                <img src={thumbsDownImg} />
              </span>
            </div>
          ) : (
            <></>
          )}
          {tagsByFlags?.map((tag, idx) =>
            tag !== 'UPTAG' && tag !== 'DOWNTAG' && tag !== 'Untagged' ? (
              <div key={idx} style={{ display: 'flex', marginBottom: '5px' }}>
                <SwitchR
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onColor="#E31690"
                  offColor="#ccc"
                  onChange={(e) => handleChangeSwitch(e, tag)}
                  checked={checkedTags[tag] || false}
                  className="react-switch"
                />
                <span
                  style={{ marginLeft: '5px', color: 'rgb(139, 142, 148)' }}
                >
                  {isRetrievalTag(tag) ? getRetrievalTagValue(tag) : tag}
                </span>
              </div>
            ) : (
              <></>
            )
          )}
        </div>
      </div>
    );
  };

  const renderFilterByUser = () => {
    return (
      <div className="filter-item">
        <div className="filter-item-div">
          <div className="filter-item-header">{'Filter by user'}</div>
          <div onClick={handleClickFUser}>
            {!displayFUser ? (
              <i
                className="fa fa-chevron-down"
                aria-hidden="true"
                style={{ color: 'rgb(139, 142, 148)' }}
              ></i>
            ) : (
              <i
                className="fa fa-chevron-up"
                aria-hidden="true"
                style={{ color: 'rgb(139, 142, 148)' }}
              ></i>
            )}
          </div>
        </div>
        <div style={{ display: !displayFUser ? 'none' : 'block' }}>
          <div
            style={{
              display: 'flex',
              marginBottom: '5px',
              color: '#8B8E94',
              fontSize: '13px',
              alignItems: 'center'
            }}
          >
            <Checkbox
              className="pdf-filter__checkbox"
              checked={
                (clickSharedFlags !== 0 &&
                  listOfUsers.length === uniqueSharers.length &&
                  uniqueSharers.length > 0) ||
                listOfUsers.includes('shared')
                  ? true
                  : false
              }
              onChange={(e) => handleChangeCheckbox(e, 'shared')}
              icon={
                <RadioButtonUncheckedIcon
                  fontSize="large"
                  style={{ color: '#8B8E94' }}
                />
              }
              checkedIcon={<CheckCircleIcon fontSize="large" />}
            />
            <span style={{ marginLeft: '5px' }} className="list-item-title">
              {'All'}
            </span>
          </div>
          <div>
            {uniqueSharers?.map((sharer, index) => (
              <div
                key={sharer.userId}
                style={{
                  display: 'flex',
                  marginBottom: '5px',
                  color: '#8B8E94',
                  fontSize: '13px',
                  alignItems: 'center'
                }}
              >
                <Checkbox
                  className="pdf-filter__checkbox"
                  checked={
                    (clickSharedFlags === 0 &&
                      listOfUsers.includes(sharer.userId)) ||
                    (listOfUsers.length > 0 &&
                      listOfUsers.includes(sharer.userId))
                      ? true
                      : false
                  }
                  onChange={(e) => handleChangeCheckbox(e, sharer.userId)}
                  icon={
                    <RadioButtonUncheckedIcon
                      fontSize="large"
                      style={{ color: '#8B8E94' }}
                    />
                  }
                  checkedIcon={<CheckCircleIcon fontSize="large" />}
                />
                <span style={{ marginLeft: '5px' }} className="list-item-title">
                  {sharer.author}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const handleClickApplyFilters = async () => {
    let tagList = [];
    let isAi = clickAiFlags;
    setIsLoadingFilters(true);

    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      const res = await getAllFlagsByDocumentUrl(
        token,
        null,
        documentUrl,
        podcastUrl,
        undefined,
        undefined,
        true,
        true,
        clickAiFlags
      );
      let isShared = false;
      const groupedList = groupedByText(res?.payload.data.sentenceInfos);
      if (clickThumbs) {
        localStorage.removeItem('listOfTags');
        tagList.push('UPTAG', 'DOWNTAG');
        setListOfTags(tagList);
        setFilterByThumbs(true);
        setClickAiFlags(false);
        isAi = false;
      } else if (filterByThumbs) {
        tagList = listOfTags?.filter(
          (item) => item !== 'UPTAG' && item !== 'DOWNTAG'
        );
        setFilterByThumbs(false);
      } else {
        tagList = listOfTags;
        setFilterByThumbs(false);
      }

      const list = await applyFilters(
        tagList,
        listOfUsers,
        groupedList,
        clickMyFlags
      );
      const myList = listOfUsers;
      if (myList?.length - 1 === uniqueSharers?.length) {
        initFetchFlags(documentUrl, list[1], list[2], clickMyFlags, true, isAi);
        setClickSharedFlags(1);
        isShared = true;
      } else if (myList?.length === 0) {
        initFetchFlags(
          documentUrl,
          list[1],
          list[2],
          clickMyFlags,
          false,
          isAi
        );
        setClickSharedFlags(0);
      } else {
        initFetchFlags(documentUrl, list[1], list[2], clickMyFlags, true, isAi);
        setClickSharedFlags(2);
        isShared = true;
      }

      setFlagFilters({
        tags: list[1],
        users: list[2],
        isMine: clickMyFlags,
        isShared: isShared,
        isAiFlags: isAi
      });
    }
    setIsLoadingFilters(false);
    handleClose();
  };

  const initFetchFlags = async (
    documentUrl,
    listOfTags,
    listOfUsers,
    isMine,
    isShared,
    isAi
  ) => {
    setFilters(true);
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      const res = await getAllFlagsByDocumentUrl(
        token,
        null,
        documentUrl,
        podcastUrl,
        listOfTags,
        listOfUsers,
        isMine,
        isShared,
        isAi
      );
      (async () => {
        const pagesAnnotations = await Promise.all(
          Array.from({ length: instance.totalPageCount }).map((_, pageIndex) =>
            instance.getAnnotations(pageIndex)
          )
        );
        const annotationIds = pagesAnnotations.flatMap((pageAnnotations) =>
          pageAnnotations.map((annotation) => annotation.id).toArray()
        );
        await instance.delete(annotationIds);
      })();
      const result = groupedByText(res?.payload.data?.sentenceInfos);
      setFlagsToShowOnRight(result);
      setPdfFlags(res?.payload.data?.sentenceInfos);
    }
  };

  useEffect(() => {
    let listTags = JSON.parse(localStorage.getItem('listOfTags'));
    let listUsers = [];

    if (
      listTags === null ||
      listTags === undefined ||
      listTags?.length === 0 ||
      (listTags && listTags[0] === 'all' && listTags?.length === 1)
    ) {
      setIsCheckedAll(true);
    } else {
      setIsCheckedAll(false);
      setListOfTags(listTags);
    }
    if (!filterByThumbs && listTags?.includes('UPTAG')) {
      setIsCheckedUp(true);
    }
    if (!filterByThumbs && listTags?.includes('DOWNTAG')) {
      setIsCheckedDown(true);
    }
    if (listTags?.includes('Untagged')) {
      setIsCheckedUntagged(true);
    }
    listTags?.map((tag) =>
      setCheckedTags((prevState) => ({
        ...prevState,
        [tag]: !prevState[tag]
      }))
    );
    if (clickSharedFlags === 0) {
      localStorage.removeItem('listOfUsers');
    } else if (clickSharedFlags === 1) {
      const mylist = uniqueSharers.map((item) => item.userId);
      listUsers = [...mylist, 'shared'];
    } else {
      listUsers = JSON.parse(localStorage.getItem('listOfUsers'));
    }
    if (listUsers !== null && listUsers !== undefined) {
      setListOfUsers(listUsers);
    }

    if (filterByThumbs) {
      setIsCheckedAll(false);
      setListOfTags(['DOWNTAG', 'UPTAG']);
      setDisplayFTag(false);
      setClickThumbs(true);
    } else {
      listTags !== null && listTags !== undefined
        ? setListOfTags([...listTags])
        : setListOfTags(['all']);
      setClickThumbs(false);
    }
  }, []);

  useEffect(() => {
    getTagsByDocument();
  }, []);

  //OSEXIQPCA-2368: get the tags that appears only in the flags of the current document
  const getTagsByDocument = () => {
    let arrayWithFlags = [];
    let arrayWithTags = [];
    let isPresentUntagged = false;

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        const res = await getAllFlagsByDocumentUrl(
          token,
          null,
          documentUrl,
          podcastUrl
        );
        const array = res.payload.data.sentenceInfos;

        if (array?.length > 0) {
          array.forEach(
            (item) => (arrayWithFlags = [...arrayWithFlags, ...item.flagsInfos])
          );
        }

        arrayWithFlags?.forEach((n) => {
          if (!arrayWithTags.includes(n.tag)) {
            if (n.tag === 'FLASH' && n.flashflag && !isPresentUntagged) {
              arrayWithTags.push('Untagged');
              isPresentUntagged = true;
            } else if (
              (n.tag === 'FLASH' && !n.flashflag && n.isMine) ||
              n.tag === 'UPTAG' ||
              n.tag === 'DOWNTAG' ||
              (n.tag !== undefined && n.tag !== 'FLASH' && n.isMine)
            ) {
              arrayWithTags.push(n.tag);
            }
          } else if (n.flashflag && !isPresentUntagged) {
            arrayWithTags.push('Untagged');
            isPresentUntagged = true;
          }
        });

        setTagsByFlags(arrayWithTags);
      });
    }
  };

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={show}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <div className="filters-popover">
          <>
            {renderFilterByTag()}
            {renderFilterByUser()}
            <div
              style={{
                display: 'flex',
                marginBottom: '5px',
                color: '#8B8E94',
                fontSize: '18px',
                alignItems: 'center'
              }}
            >
              <div>
                <Checkbox
                  className="pdf-filter__checkbox"
                  checked={clickThumbs}
                  onChange={(e) => handleChangeCheckbox(e, 'thumbs')}
                  icon={
                    <RadioButtonUncheckedIcon
                      fontSize="large"
                      style={{ color: '#8B8E94' }}
                    />
                  }
                  checkedIcon={<CheckCircleIcon fontSize="large" />}
                />
              </div>
              <div>
                <span className="filter-item-header">Display</span>
                {clickThumbs ? (
                  <img src={thumbsActive} />
                ) : (
                  <img src={thumbsInactive} />
                )}
              </div>
            </div>
            {renderApplyFiltersButton()}
          </>
        </div>
      </Popover>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllFlagsByDocumentUrl: async (
      token,
      pageStart,
      documentUrl,
      podcastUrl,
      tags,
      users,
      isMine,
      isShared,
      isAiFlags
    ) => {
      const res = await dispatch(
        fetchAllFlagsByDocumentUrl(
          token,
          pageStart,
          documentUrl,
          podcastUrl,
          tags,
          users,
          isMine,
          isShared,
          isAiFlags
        )
      );
      return res;
    },
    setPdfFlags: async (value) => {
      await dispatch(setPdfFlags(value));
    },
    setFilters: async (value) => {
      await dispatch(setFilters(value));
    },
    setFilterByThumbs: async (value) => {
      await dispatch(setFilterByThumbs(value));
    },
    setTypeFilter: async (value) => {
      await dispatch(setTypeFilter(value));
    },
    setFlagFilters: async (value) => {
      await dispatch(setFlagFilters(value));
    }
  };
};

const mapStateToProps = (state) => ({
  allFlagsByDocument: state.pdf.allFlagsByDocument,
  filterByThumbs: state.pdf.filterByThumbs,
  typeFilter: state.pdf.typeFilter
});

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
